import { gql } from '@apollo/client';
import {
  sharedInvoiceInput,
  sharedInvoiceInputFields,
} from '../../fragments/invoice-input';
import CollectionActionMinimalFields from '../../fragments/collection-action/collection-action-minimal-fields';
import MoneyFields from '../../fragments/money/money-fields';
import MasterEntityMinimalFields from '../../fragments/master-entity/master-entity-minimal-fields';
import OfferMinimalFields from '../../fragments/offer/offer-minimal-fields';
import { InvoiceReviewDocumentsFields } from '../../fragments/invoice/invoice-review-documents-fields';
import NoteFields from '../../fragments/invoice/note-fields';
import ReferenceFields from '../../fragments/invoice/reference-fields';
import CompanyEvaluationRestrictionMinimalFields from '../../fragments/company-evaluation-restriction/company-evaluation-restriction-minimal-fields';
import ExecutiveFields from '../../fragments/user/executive-fields';

const CLIENT_ASSIGNMENTS = gql`
  query clientAssignments(${sharedInvoiceInputFields}) {
    invoices(${sharedInvoiceInput}) {
      totalCount
      edges {
        cursor
        node {
          id
          folio
          dateOperation
          dateIssued
          dateToPay
          paymentDate
          collectionDate
          status
          siiStatus
          creditNoteStatus
          isRatificated
          isRevolving
          amountWithIva {
            ...MoneyFields
          }
          company {
            id
            masterEntity {
              id
            }
            executiveAssigned {
              ...ExecutiveFields
            }
          }
          receiver {
            ...MasterEntityMinimalFields
          }
          paymentDiscounts {
            id
            paymentAmountAfterNegativeSurplus {
              ...MoneyFields
            }
          }
          offer {
            ...OfferMinimalFields
          }
          operation {
            id
          }
          surplusDebt {
            ...MoneyFields
          }
          ...InvoiceReviewDocumentsFields
          historystatusSet {
            id
            status
            createdAt
          }
          lastHistoryStatus {
            id
            status
          }
          collectionManager {
            id
            actions {
              ...CollectionActionMinimalFields
            }
          }
          references {
            ...ReferenceFields
          }
          creditNotes @client {
            ...NoteFields
          }
          debitNotes @client {
            ...NoteFields
          }
          restrictedBy {
            ...CompanyEvaluationRestrictionMinimalFields
          }
        }
      }
    }
  }
  ${CollectionActionMinimalFields}
  ${MoneyFields}
  ${MasterEntityMinimalFields}
  ${OfferMinimalFields}
  ${InvoiceReviewDocumentsFields}
  ${ReferenceFields}
  ${NoteFields}
  ${CompanyEvaluationRestrictionMinimalFields}
  ${ExecutiveFields}
`;

export default CLIENT_ASSIGNMENTS;
